import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Whether this stakeholder is a formal or potential change champion / advocate.',
    isOptional: true,
    name: 'Change Champion?',
    partialId: PartialId.Standard.create('change_champion'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.stakeholderChangeChampion.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
